import React, { createContext, ReactNode } from "react";
import { useSessionStorage } from "../utils/hooks/useSessionStorage";
import { IAuthContext, User } from "../types/auth";
import { IsValidJwtToken } from "../utils/helpers/auth";
import settings from "../settings";
import { routeUrls } from "../config/routeUrls";

export const AuthContext = createContext(null as (null | IAuthContext));

interface Props {
	children: ReactNode
}

export const AuthProvider: React.FC<Props> = ({ children }) => {
	const [user, setUser] = useSessionStorage("user", null) as [(User | null), (newValue: (User | null)) => void];	

	// LOGIN: call this function when you want to authenticate the user
	const login = () => {
		const parsedToken: any = IsValidJwtToken();
		const accountId = window.sessionStorage.getItem("accountId");
		const contactId = window.sessionStorage.getItem("contactId");

		if (!!parsedToken && !!accountId && !!contactId) {
			setUser({
				accountId: accountId,
				contactId: contactId,
				email: parsedToken.email,
				fullName: parsedToken.given_name + ' ' + parsedToken.family_name,
				name: parsedToken.given_name
			})
		}
	};

	// call this function to sign out logged in user
	const logout = () => {
		const idToken = window.sessionStorage.getItem("idToken");
		window.sessionStorage.clear();

		var logoutUrl = settings.idpBaseUrl + settings.idpLogoutEndpoint +
			"?id_token_hint=" + idToken +
			"&post_logout_redirect_uri=" + encodeURIComponent(window.location.origin + routeUrls.dashboard);

		window.location.href = logoutUrl;
	};

	const value: IAuthContext = {
		user,
		login,
		logout,
	};

	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};